module.exports = __webpack_public_path__ + "img/type-11.6449aae3.jpg";